import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "18",
      height: "11",
      x: "6",
      y: "13",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      rx: "3"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10 13V9a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "15",
      cy: "18.5",
      r: "1.25",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }